const Constant = {
	cookie: {
		RECENT_SEARCH_LIST: 'RECENT_SEARCH_LIST',
		RECENT_SEARCH_REGIST_LIST: 'RECENT_SEARCH_REGIST_LIST',
		RECENT_SEARCH_MSDS: 'RECENT_SEARCH_MSDS',
		RECENT_SEARCH_DANGER_STORAGE: 'RECENT_SEARCH_DANGER_STORAGE',
		RECENT_SEARCH_HAZARDOUS_MATERIAL: 'RECENT_SEARCH_HAZARDOUS_MATERIAL',
		RECENT_SEARCH_SPECIAL_MANAGEMENT: 'RECENT_SEARCH_SPECIAL_MANAGEMENT',
		RECENT_SEARCH_HEALTH_CHECK: 'RECENT_SEARCH_HEALTH_CHECK',
		RECENT_SEARCH_LAW_MATERIAL: 'RECENT_SEARCH_LAW_MATERIAL',
		SPECIAL_MANAGEMENT_HIDE_ALWAYS: 'SPECIAL_MANAGEMENT_HIDE_ALWAYS',
		RECENT_SEARCH_LAW_PRODUCT_BY_GROUP:
			'RECENT_SEARCH_LAW_PRODUCT_BY_GROUP',
		RECENT_SEARCH_ORGANIZATION: 'RECENT_SEARCH_ORGANIZATION',
		RECENT_SEARCH_MEMBER: 'RECENT_SEARCH_MEMBER',
	},
	recentSearchListSize: 20,
	dataCallListSize: 20,
	maxQuantity: 10,
	inventoryImageMaxSize: 10,
	formatDate: 'yyyy-MM-dd',
	formatDatetime: 'yyyy-MM-dd HH:mm',
	formatDashDatetime: 'yyyy-MM-dd HH:mm:ss',
	formatDashDate: 'yyyy-MM-dd',
	NotificationType: {
		Common: 'common',
	},
	MaxCreateQuantity: 999,
}

export default Constant
